import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';

type MeshGatewayDeviceRegistrationEndpointSpecification = ApiEndpointSpecification;
export const MeshGatewayDeviceRegistrationEndpointSpecification: MeshGatewayDeviceRegistrationEndpointSpecification = {
    url: '/api/champ/mesh/registration',
    method: HttpMethod.POST,
    requestParamsSchemaName: 'MeshGatewayDeviceRegistrationRequestParams',
    requestBodySchemaName: 'MeshGatewayDeviceRegistrationRequestBody',
    okResponseSchemaName: 'MeshGatewayDeviceRegistrationOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
};

export const invokeMeshGatewayDeviceRegistration = Helpers.makeApiRequestFn<
    Types.MeshGatewayDeviceRegistrationRequestParams,
    Types.MeshGatewayDeviceRegistrationRequestBody,
    Types.MeshGatewayDeviceRegistrationOkResponse
>(MeshGatewayDeviceRegistrationEndpointSpecification);
